

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <perfil></perfil>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import perfil from '@/components/perfil/Perfil.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    perfil
    
  },

  methods: {

}

}
    

</script>
